import { IconBookmark, IconBuildings, IconInfo, IconPencil, IconShare, IconTools } from '@assets/images/icon';
import { IconFacetime, IconTopology } from '@assets/images/main';
import { cameraEdge, camreaServer } from '@assets/images/main/camera';
import { IconCctvOff } from '@assets/images/main/icon';

export default {
  a: [
    { text: '製品概要', icon: IconInfo },
    { text: '処理構成', icon: IconTopology },
    { text: '映像取得方式', icon: IconFacetime },
    { text: '対応カメラ台数', icon: IconCctvOff },
    { text: '設置方法', icon: IconTools },
    { text: '活用空間', icon: IconBuildings },
    { text: '推奨環境', icon: IconBookmark },
    { text: '主な特長', icon: IconPencil },
    { text: '外部連携', icon: IconShare },
  ],

  b: [
    { text: '1台にAI分析とORBRO OSを内蔵' },
    { text: 'Edge端末単体で運用可能（ORBRO OS搭載）' },
    { text: 'RTSP / ONVIFなどネットワーク映像取得に対応' },
    { text: '最大2台まで対応' },
    { text: '電源とカメラ接続だけで簡単設置' },
    { text: '出入口、狭い室内、小規模施設向け' },
    { text: 'サーバー不要でスピード導入・基本機能重視の現場' },
    { text: '1台で設置・運用可能、低コスト構成' },
    { text: '一部API提供（基本連携が可能）' },
  ],

  c: [
    { text: 'サーバーベースの高性能AI映像分析システム' },
    { text: 'AI Server + ORBRO Server との連携運用' },
    { text: 'RTSP / ONVIFなどネットワーク映像取得に対応' },
    { text: '6台以上対応（サーバー拡張により対応可能）' },
    { text: 'サーバールームや監視室を中心としたネットワーク構成' },
    { text: '大規模病院、物流センター、官公庁などの統合監視用途' },
    { text: '中〜大規模施設での多チャンネル映像分析に最適' },
    { text: 'ORBRO OSのSOP・ヒートマップ・ゾーン等の高度機能と完全連携' },
    { text: 'API提供（リアルタイムイベント・位置・状況連携対応）' },
  ],

  spec: [
    {},

    {
      image: cameraEdge,
      link: '/camera/edge',
      title: 'ORBRO Edge AI',
      desc: '',
    },

    {
      image: camreaServer,
      link: '/camera/server',
      title: 'ORBRO AI Server',
      desc: '',
    },
  ],
};
